export const FADE_IN_DURATION_MS = 1500;
export const TRANSITION_DURATION_MS = 100;
export const SPACE_BETWEEN_COINS = 0.05;
export const COINS_COUNT = 15;
export const COINS_SPREAD_SIZE = 10;
export const COIN_WIDTH = 42;
export const GC_COIN_LANDING_OFFSET = -5;
